module.exports = __webpack_public_path__ + "media/images/flags/pl-e2978cd583d46dfe1682d0f83fdc3f59.svg";